export default __webpack_public_path__ + "static/media/referAFriend@3x.ecd6500b.png";